module.exports = __webpack_public_path__ + "70a290afe3dffa54924e7ddffd767687.svg";